import { render, staticRenderFns } from "./AnredenManagement.vue?vue&type=template&id=2ef16a70&scoped=true"
import script from "./AnredenManagement.vue?vue&type=script&lang=js"
export * from "./AnredenManagement.vue?vue&type=script&lang=js"
import style0 from "./AnredenManagement.vue?vue&type=style&index=0&id=2ef16a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef16a70",
  null
  
)

export default component.exports